
import React from "react";
import PageHeader from "../../components/PageHeader";
import AppUserUpdateComponent from "../../components/AppUsers/AppUserUpdate";

class AppUserUpdate extends React.Component {
    componentDidMount() {
        window.scrollTo(0, 0);
    }
    render() {
        return (
            <div
                style={{ flex: 1 }}
                onClick={() => {
                    document.body.classList.remove("offcanvas-active");
                }}
            >
                <div>
                    <div className="container-fluid">
                        <PageHeader
                            HeaderText="AppUser Update"
                            Breadcrumb={[
                                { name: "Users", navigate: "/app-users" },
                                { name: "User Update", navigate: "" },
                            ]}
                        />
                        <div className="row clearfix">
                            <AppUserUpdateComponent />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default AppUserUpdate;
